import React from 'react'
import {
  ThemeProvider,
  lightTheme,
  Grid,
  DemoSettingsForm
} from '@rodeo-dev/legos'

import AppContext from '../../../app-context'
import app from '../../../app.jsx'
import BaseSettings from '../../page/base_setting/base_setting.jsx'
import demotemplateCrud from '../../../../shared/util/demo/demotemplateCrud'

class PageDemoSetting extends BaseSettings {
  static contextType = AppContext

  constructor (props) {
    super(props, 'setting-demodata', 'setting-user', 'setting-demodata')

    this._references = {
      pageHeader: React.createRef()
    }

    this.state = {
      loading: true,
      dataDate: null,
      isGenerateNewDemoVersionDisabled: false
    }

    this.data = {
      demoVersions: []
    }

    this._bUnMounted = false
  }

  componentDidMount () {
    this._getData()
  }

  renderContent () {
    return this.state.loading ? (
      ''
    ) : (
      <ThemeProvider theme={lightTheme}>
        <div className='ratecard-form'>
          <Grid container>
            <Grid item sm={12}>
              <DemoSettingsForm
                demoVersions={this.data.demoVersions}
                tableTitle='Demo Data Versions'
                onGenerateNewDemoVersion={() => this._generateNewDemoVersion()}
                onActivateDemoVersion={demoVersion =>
                  this._activateDemoVersion(demoVersion)}
                disableGenerateNewDemoVersionButton={this.state.isGenerateNewDemoVersionDisabled}
              />
            </Grid>
          </Grid>
        </div>
      </ThemeProvider>
    )
  }

  _getData () {
    this._getPageDataWithPromises()
      .then(this._getDemoVersions.bind(this))
      .finally(this._onDataReceived.bind(this))
  }

  _onDataReceived (err) {
    if (this._bUnMounted) return

    if (err) {
      app.debug('PageDemoSetting: _onDataReceived Error', err)
    } else {
      app.debug('PageDemoSetting: _onDataReceived [done]')
    }
    this.setState({
      loading: !!err,
      dataDate: new Date(),
      saving: false,
      isGenerateNewDemoVersionDisabled: false
    })
  }

  _getDemoVersions () {
    app.debug('PageDemoSetting: _getDemoVersions [start]')
    this.data.demoVersions = []
    return demotemplateCrud.getTemplateList(app, app.teamCountry).then(result => {
      this.data.demoVersions = result.reverse()
    })
  }

  _generateNewDemoVersion () {
    this.setState({ isGenerateNewDemoVersionDisabled: true })

    return demotemplateCrud
      .createTemplate(app, app.teamCountry)
      .then(() => this._getData())
  }

  _activateDemoVersion (demoVersion) {
    return demotemplateCrud
      .setActiveTemplate(app, demoVersion.version, app.teamCountry)
      .then(() => this._getData())
  }
}

export default PageDemoSetting
